module.exports = __webpack_public_path__ + "static/prospectus-3c8c8d247d56251132f286b5e3793d06.pdf";